/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs */

const en_admin_ai_chat_approval_ask_tool_call_check_out = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant wants to check out a member`)
};

const de_admin_ai_chat_approval_ask_tool_call_check_out = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Assistent möchte ein Mitglied auschecken.`)
};

const es_admin_ai_chat_approval_ask_tool_call_check_out = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El asistente quiere registrar la salida de un miembro.`)
};

const fr_admin_ai_chat_approval_ask_tool_call_check_out = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'assistant souhaite enregistrer la sortie d'un membre.`)
};

const nl_admin_ai_chat_approval_ask_tool_call_check_out = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De assistent wil een lid uitchecken.`)
};

const it_admin_ai_chat_approval_ask_tool_call_check_out = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'assistente vuole registrare l'uscita di un membro.`)
};

const pt_br2_admin_ai_chat_approval_ask_tool_call_check_out = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O assistente quer fazer o check-out de um membro.`)
};

const pl_admin_ai_chat_approval_ask_tool_call_check_out = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asystent chce wymeldować członka.`)
};

/** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs) => LocalizedString} */
const hu_admin_ai_chat_approval_ask_tool_call_check_out = en_admin_ai_chat_approval_ask_tool_call_check_out;

/** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs) => LocalizedString} */
const ro_admin_ai_chat_approval_ask_tool_call_check_out = en_admin_ai_chat_approval_ask_tool_call_check_out;

/**
* | output |
* | --- |
* | "The assistant wants to check out a member" |
*
* @param {Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_approval_ask_tool_call_check_out = /** @type {((inputs?: Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Approval_Ask_Tool_Call_Check_OutInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_approval_ask_tool_call_check_out(inputs)
	if (locale === "de") return de_admin_ai_chat_approval_ask_tool_call_check_out(inputs)
	if (locale === "es") return es_admin_ai_chat_approval_ask_tool_call_check_out(inputs)
	if (locale === "fr") return fr_admin_ai_chat_approval_ask_tool_call_check_out(inputs)
	if (locale === "nl") return nl_admin_ai_chat_approval_ask_tool_call_check_out(inputs)
	if (locale === "it") return it_admin_ai_chat_approval_ask_tool_call_check_out(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_approval_ask_tool_call_check_out(inputs)
	if (locale === "pl") return pl_admin_ai_chat_approval_ask_tool_call_check_out(inputs)
	if (locale === "hu") return hu_admin_ai_chat_approval_ask_tool_call_check_out(inputs)
	return ro_admin_ai_chat_approval_ask_tool_call_check_out(inputs)
});
export { admin_ai_chat_approval_ask_tool_call_check_out as "admin.ai_chat.approval_ask_tool_call.check_out" }